/**
 * @description This is for the global directory. 
 */
import axios from "axios";
let users = []
let actions = {
    /**
     * @returns {Promise<Array>}
     */
    login(username, password) {
        return new Promise((resolve, reject) => {
            axios.put("/admin/login", {
                username: username,
                password: password
            })
                .then(data => {
                    let token = data.data.token;
                    console.log(token);
                    localStorage.setItem("token", token)
                    resolve(users);
                })
                .catch(err => {
                    reject(err);
                })
        })
    },
    logout() {
        return new Promise((resolve, reject) => {
            axios.put("/admin/logout")
                .then(data => {
                    localStorage.removeItem("token")
                    resolve()
                })
                .catch(err => {
                    reject(err);
                })
        })
    },
    isAlive() {
        return new Promise((resolve, reject) => {
            axios.get("/admin/isalive")
                .then(data => {
                    resolve(data.data.object.isalive);
                })
                .catch(err => {
                    reject(err);
                })
        })
    }
}
export default actions;